export const tokenAddresses = {
  EUL: "0x5B18925B3188632789b98088C8763FeF49FF3Bb5",
  eUSD: "0x0000000000000000000000000000000000000000",
  rEUL: "0x593257c097e5Bd2E619cDDC48136f1D6cC3C621b",
  seUSD: "0x0000000000000000000000000000000000000000",
} as const
